import { IconComponent } from '@backstage/frontend-plugin-api';

const ICON_PX = 24;

/**
 * Icon for one toolkit link. The SVG files are currentColor artwork served
 * from /assets/toolkit, so the shape is painted with the surrounding color
 * at the default 24px icon size.
 */
export function createToolkitIcon(name: string): IconComponent {
  const ToolkitIcon: IconComponent = () => (
    <svg
      width={ICON_PX}
      height={ICON_PX}
      viewBox={`0 0 ${ICON_PX} ${ICON_PX}`}
      aria-hidden
      focusable="false"
      style={{
        display: 'block',
        width: ICON_PX,
        height: ICON_PX,
        maskImage: `url(/assets/toolkit/${name}.svg)`,
        WebkitMaskImage: `url(/assets/toolkit/${name}.svg)`,
        maskRepeat: 'no-repeat',
        WebkitMaskRepeat: 'no-repeat',
        maskPosition: 'center',
        WebkitMaskPosition: 'center',
        maskSize: 'contain',
        WebkitMaskSize: 'contain',
        maskMode: 'alpha',
      }}
    >
      <rect width={ICON_PX} height={ICON_PX} fill="currentColor" />
    </svg>
  );

  ToolkitIcon.displayName = `ToolkitIcon(${name})`;
  return ToolkitIcon;
}
